import React, { memo, useMemo } from 'react';
import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Separator } from '@r1-frontend/ui-react/components/Separator';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { FullWidthListContainer, IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import {
    AdditionalEquipmentWithToggle,
} from '~/src/features/full-buy/containers/AdditionalEquipment/AdditionalEquipmentWithToggle';
import {
    TEquipmentComponent,
    useCheckAdditionalEquipment,
} from '~/src/features/full-buy/containers/AdditionalEquipment/useCheckAdditionalEquipment';
import { DecoderList } from '~/src/features/full-buy/containers/DecoderList';
import { EquipmentList, TRouterListProperties } from '~/src/features/full-buy/containers/EquipmentList';

const componentForEquipment: Record<TEquipmentComponent, ((props: TRouterListProperties)=> JSX.Element) | null> = {
    'all': AdditionalEquipmentWithToggle,
    'routers': EquipmentList,
    'decoders': DecoderList,
    'none': null,
};

const AdditionalEquipment = ({ className } : { className?: string }) => {
    const {
        hasAdditionalEquipment,
        equipmentComponentType,
        routerCategory,
    } = useCheckAdditionalEquipment();

    const EquipmentComponent = useMemo(
        () => componentForEquipment[equipmentComponentType],
        [equipmentComponentType],
    );

    if (!hasAdditionalEquipment || !EquipmentComponent) {
        return null;
    }

    return <WideContainer className={className}>
        <FullWidthListContainer $direction={'column'} $size={0}>
            <IndentContainer $united={[0, 0, 24]}>
                <Separator $color={COLORS.BgSurface}/>
            </IndentContainer>
            <H3 $withIndent={equipmentComponentType === 'all'}> Вам может понадобиться оборудование</H3>
            <EquipmentComponent withCarousel={true} category={routerCategory}/>
        </FullWidthListContainer>
    </WideContainer>;
};

const StyledAdditionalEquipment = styled(AdditionalEquipment)`
    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: -32px;
    }
`;

export default memo(StyledAdditionalEquipment);
